import AndroidSection from "@/components/AndroidSection";

export default function AndroidPage() {
    return (
        <div className="pt-16">
            <AndroidSection />
        </div>
    );
}
